module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Dodaj administratora\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.users.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć do administratorów")])], 1), _vm._v(" "), _c('users-form', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81a91242","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/Create.vue
// module id = 277
// module chunks = 0